import "../css/InputIntButton.css";

export default ({ label, onClick }) => {
  return (
    <button className="inputintbutton" onClick={onClick}>
      {label}
    </button>
  );
};
